Vue.component("dropdown", {
	template: '<div class="dropdown" v-if="menuItems.length > 0"><div data-toggle="dropdown" class="dropdown-toggle" aria-expanded="false"><div class="dial-handle-container"><slot name="icon"></slot></div><div class="current-selection">{{ menuItems[selectedIndex] }}</div><div class="menu-arrow glyphicon glyphicon-menu-down"></div></div><ul role="menu" class="dropdown-menu" :class="[menuRight]"><li role="menuitem" v-for="(item, index) in menuItems" v-on:click="onSelectItem(index)"v-bind:class="{ selected: (index == selectedIndex) }"><a>{{ item }}</a></li></ul></div>',
	props: {
		menuItems: Array,
		selectedIndex: 0,
		align: {
			type: String,
			default: 'left',
			validate: (value) => ['left', 'right'].includes(value)
		}
	},

	methods: {
		onSelectItem: function (index) {
			this.$emit("select", index);

			// When a change has been made to either of interval or graph it is reported to Google Analytics
			var headerName = this.$el.parentElement.parentElement.childNodes[0].textContent;
			if (headerName == 'GRAPH' || headerName == 'INTERVAL') {
				var report = headerName + ' -> ' + this.$options.propsData.menuItems[index];
				ga('send', 'Statistics, dropdown state:, ' + report);
			}
		}
	},

	computed: {
		menuRight() {
			return {
				'dropdown-menu-right': this.align === 'right'
			}
		}
	}
});
